import { css } from '@emotion/css'
import { fontWeight } from '../../styles'

const styles = {
  button: css({
    // Override default button styling
    border: 'none',
    background: 'none',
    outline: 'none',
    padding: 0,
    fontWeight: fontWeight.default,
  }),
}

export default styles
